import api from '@/services/api';
import FileSaver from 'file-saver';

const textWrapperDispatchMiddleware = (dispatch, currentState) => {
	return (action) => {
		switch (action.type) {
			case 'fetchLetter':
				// first get letters data
				api.get(`/letters/${action.payload.letterId}`)
					.then(({ data: lettersData }) => {
						action.payload = { ...action.payload, ...lettersData };
					})
					.then(() => {
						api.get(`/texts/${action.payload.letterId}`)
							.then(({ data: textsData }) => {

								action.payload = { ...action.payload, ...textsData };
								dispatch(action);
							});
					});
				break;

			case 'highlightText':
				// eslint-disable-next-line no-case-declarations
				const newCaret = { ...currentState.caret };
				// when user highlights some text - get entire letter data with highlighting
				if (currentState.caret.text.substring(currentState.caret.text.length - 1) === ' ') {
					newCaret.end -= 1;
					newCaret.text = currentState.caret.text.substring(0, currentState.caret.text.length - 1);
				}
				dispatch({ type: 'setTempCaret', payload: newCaret });
				api.put(`/texts/${currentState.letterId}/original/highlighting`, newCaret)
					.then(({ data }) => {
						dispatch({ ...action, payload: data });
					});
				break;

			case 'clearHighlightText':
				api.put(`/texts/${currentState.letterId}/original/highlighting`, {
					end: 0,
					start: 0,
					text: '',
				}).then(
					({ data }) => {
						dispatch({ type: "clearHighlightText", payload: data });
					});
				break;

			case 'loadChangesHistory':
				// when user clicks change handler above the text
				dispatch({ type: 'historyIsLoading' });
				// return dispatch({ ...action, payload: { ...data, changeId: action.payload.changeId } });
				if (action.payload.changeId) {
					api.get(`/texts/${currentState.letterId}/changes/${action.payload.changeId}/history`)
						.then(({ data }) => {
							return dispatch({ ...action, payload: { ...data, changeId: action.payload.changeId } });
						});
				}
				break;

			case 'handleChangeConfirmed':
				dispatch({ type: 'historyIsLoading' });
				if (action.payload.change) {
					const { change } = action.payload;
					
					api.post(`/texts/${currentState.letterId}/changes`, {
						start: (change.start ? change.start : currentState.tempCaret.start),
						end: (change.end ? change.end : currentState.tempCaret.end),
						content: change.content,
						footnote: change.annotation,
						motivation: change.reason,
					}).then(({ data }) => {
						return dispatch({ ...action, payload: { ...action.payload, ...data } });
					});
				}
				break;

			case 'deleteChange':
				api.delete(`/texts/${currentState.letterId}/changes/${action.payload.changeId}`).then(({ data }) => {
					return dispatch({ ...action, payload: { ...action.payload, ...data } });
				});
				break;

			case 'handleChangeEditConfirmed':
				api.put(`/texts/${currentState.letterId}/changes/${action.payload.changeId}`, {
					content: action.payload.content,
					footnote: action.payload.annotation,
					motivation: action.payload.reason,
				}).then(({ data }) => {
					return dispatch({ ...action, payload: data });
				});
				return dispatch({
					type: 'setRequesIsPending', payload: {
						requestPending: true,
					},
				});

			case 'handleDownloadFile':
				// eslint-disable-next-line no-case-declarations
				let mode = 'original';
				switch (action.payload.currentMode) {
					case 'simplifiedDoc':
						mode = 'simplified';
						break;
					case 'finalDoc':
						mode = 'final';
						break;
					default:
						mode = 'original';
						break;
				}
				api.get(`letters/${currentState.letterId}/${mode}/docx`, { responseType: 'blob' })
					.then((response) => {
						let fileName = response.headers["content-disposition"].split("filename=")[1];
						fileName = fileName.replaceAll('"','');
						FileSaver.saveAs(response.data, fileName);
					});
				return dispatch(action);

			case 'submitLetterMetadataEdit':
				api.put(`letters/${currentState.letterId}`, action.payload).then(({ data }) => {
					return dispatch({ ...action, payload: data });
				});
				break;

			case 'addChangeToDict':
				api.post(`/dict-entries/${currentState.letterId}/${action.payload.changeId}`)
					.then(({ data }) => {
						dispatch({ ...action, payload: { ...data, changeId: action.payload.changeId } });
					});
				break;

			case 'suggestAutomaticChanges':
				dispatch({
					type: 'setAutoChangesIsLoading', payload: {
						autoChangesIsLoading: true,
					},
				});
				api.post(`auto/${currentState.letterId}/changes`)
					.then(({ data }) => {
						dispatch({ ...action, payload: { ...data } });
						dispatch({
							type: 'setAutoChangesIsLoading', payload: {
								autoChangesIsLoading: false,
							},
						});
					});
				break;

			case 'suggestAutomaticFixes':
				dispatch({
					type: 'setAutoChangesIsLoading', payload: {
						autoChangesIsLoading: true,
					},
				});
				api.post(`auto/${currentState.letterId}/changes/corrections`)
					.then(({ data }) => {
						dispatch({ ...action, payload: { ...data } });
						dispatch({
							type: 'setAutoChangesIsLoading', payload: {
								autoChangesIsLoading: false,
							},
						});
					});
				break;
				
			case 'removeAutomaticChanges':
				dispatch({
					type: 'setAutoChangesIsLoading', payload: {
						autoChangesIsLoading: true,
					},
				});
				api.delete(`auto/${currentState.letterId}/changes`)
					.then(({ data }) => {
						dispatch({ ...action, payload: { ...data } });
						dispatch({
							type: 'setAutoChangesIsLoading', payload: {
								autoChangesIsLoading: false,
							},
						});
					});
				break;

			case 'popoverMenuSelectChange':
				dispatch({ type: 'historyIsLoading' });
				api.post(`auto/${currentState.letterId}/changes/select/${action.payload.changeId}`)
					.then(({ data }) => api.get(`/texts/${currentState.letterId}/changes/${data.changeId}/history`)
						.then(({ data: changes }) => {
							return dispatch({ ...action, payload: { ...data, changes } });
						}));
				break;

			case 'popoverMenuSelectChangeAndDeleteRemainingAutomatic':
				dispatch({ type: 'historyIsLoading' });
				api.delete(`auto/${currentState.letterId}/changes/select/${action.payload.changeId}`)
					.then(({ data }) => api.get(`/texts/${currentState.letterId}/changes/${data.changeId}/history`)
						.then(({ data: changes }) => {
							return dispatch({ ...action, payload: { ...data, changes } });
						}));
				break;

			default:
				return dispatch(action);
		}
	};
};
export default textWrapperDispatchMiddleware;
